module.exports = __webpack_public_path__ + "media/images/athletes/1402-304bca87c83bdbc181cea7cc759e919d.png";